/**
 * ToggleRow — single labelled on/off control row used by AccessibilityWidget.
 * Extracted verbatim from AccessibilityWidget.tsx.
 */

import React from 'react';

/* ── Toggle item renderer ── */
export const ToggleRow: React.FC<{
  icon: React.ElementType;
  label: string;
  ariaLabel: string;
  active: boolean;
  onToggle: () => void;
}> = ({ icon: Icon, label, ariaLabel, active, onToggle }) => (
  <button
    onClick={onToggle}
    aria-label={ariaLabel}
    aria-pressed={active}
    className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${
      active
        ? 'bg-gray-900/25 text-gray-500'
        : 'text-slate-300 hover:bg-slate-800'
    }`}
  >
    <Icon className="w-4 h-4 shrink-0" />
    <span className="flex-1 text-left">{label}</span>
    <span
      className={`relative w-9 h-5 rounded-full transition-colors ${
        active ? 'bg-gray-900' : 'bg-slate-600'
      }`}
    >
      <span
        className={`absolute top-0.5 w-4 h-4 rounded-full bg-white transition-transform ${
          active ? 'left-[18px]' : 'left-0.5'
        }`}
      />
    </span>
  </button>
);
